import * as React from 'react';
import * as styles from "./ViewPanelRecurrenceEditPopup.css";
import { LocalizationService } from '../../../../services/LocalizationService';
import { IAButton } from '../../../button/Button';

export interface IViewPanelRecurrenceEditPopupProps {
  highlightColor: string;
  onEditCallback: (editOcurrence: boolean) => void;
  onRemovePopupCallback: () => void;
}

export interface IViewPanelRecurrenceEditPopupState {
}

export class ViewPanelRecurrenceEditPopup extends React.Component<IViewPanelRecurrenceEditPopupProps, IViewPanelRecurrenceEditPopupState> {
  private readonly localizationService = new LocalizationService();
  private readonly recurrenceEditPopupId = "recurrenceEditPopup";

  constructor(props: IViewPanelRecurrenceEditPopupProps) {
    super(props);
    this.state = {
    };
  }

  public componentDidMount() {
    document.addEventListener('mousedown', this.removeRecurrencePopupCallback);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.removeRecurrencePopupCallback);
  }

  removeRecurrencePopupCallback = (event: MouseEvent) => {
    const popup = document.getElementById(this.recurrenceEditPopupId);
    if (popup && !popup.contains(event.target as Node)) {
      this.props.onRemovePopupCallback();
    }
  }

  public render(): JSX.Element {
    return <div
        className={styles.IA_recurrenceEditPopupWrapper}
        id={this.recurrenceEditPopupId}
      >
        {this.localizationService.strings.Events_EditOccurrenceOrSeries}
        <div className={styles.IA_recurrenceEditPopupButtons}>
          <IAButton
            label={this.localizationService.strings.Events_Occurrence}
            buttonColor={this.props.highlightColor}
            borderRadius={5}
            onClick={() => this.props.onEditCallback(true)}
          />
          <IAButton
            label={this.localizationService.strings.Events_Series}
            buttonColor={this.props.highlightColor}
            borderRadius={5}
            onClick={() => this.props.onEditCallback(false)}
          />
        </div>
      </div>;
  }
}